<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">考核评分系统</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="ruleForm.username" placeholder="username" @keyup.enter.native='setPassFocus()'>
                        <el-button slot="prepend" icon="el-icon-user"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="password" ref="passFocus" show-password v-model="ruleForm.password" @keyup.enter.native="submitForm('ruleForm')">
                        <el-button slot="prepend" icon="el-icon-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')">登录</el-button>
                </div>
                <p class="login-tips" v-show="tips">{{tips}}</p>
            </el-form>
        </div>
    </div>
</template>

<script>
    import storage from '@/assets/js/storage'
    export default {
        data(){
            return {
                loading:false,
                tips:'',    //登录失败提示
                ruleForm: {
                    username: '',//orange.o
                    password: '',//123456
                },
                rules: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            submitForm(formName) { //登录
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading=true;
                        this.$http.post('/login',this.ruleForm).then((v)=>{
                            if(v.status === 200 && v.data.message === "login success"){
                                const item={
                                    user:v.data.data.staff,
                                    token:v.data.data.token,
                                    time:new Date().getTime()/1000,
                                    expires:v.data.data.expires_in,
                                    rank:v.data.data.role,
                                    menus:v.data.data.menus,
                                }
                                storage.localSet('user',item);
                                this.$store.commit('setUserInfo',v.data.data);
                                this.$router.push('/');
                            }
                            this.loading=false;
                        }).catch((v)=>{
                            this.loading=false;
                            // this.tips=v.data.message;
                        })
                    } else {
                        return false;
                    }
                });
            },
            setPassFocus(){ //username  keyup password
                this.$refs.passFocus.$refs.input.focus()
            }
        }
    }
</script>

<style scoped>
    .login-wrap{
        position: relative;
        width:100%;
        height:100%;
        /* background-image: url(../../assets/img/login-bg.jpg); */
        background: url(../../assets/img/login-bg.jpg) no-repeat;
        background-size: cover;
        background-position: 50%;
    }
    .ms-title{
        width:100%;
        line-height: 50px;
        text-align: center;
        font-size:20px;
        color: #fff;
        border-bottom: 1px solid #ddd;
    }
    .ms-login{
        position: absolute;
        left:50%;
        top:50%;
        width:350px;
        margin:-190px 0 0 -175px;
        border-radius: 5px;
        background: rgba(255,255,255, 0.3);
        overflow: hidden;
    }
    .ms-content{
        padding: 30px 30px;
    }
    .login-btn{
        text-align: center;
    }
    .login-btn button{
        width:100%;
        height:36px;
        margin-bottom: 10px;
    }
    .login-tips{
        font-size:12px;
        color:red;
        margin-bottom: 0;
    }
</style>